// Gepinnter Horizontal-Scroll: vertikales Scrollen treibt den Slider horizontal,
// die Section bleibt gepinnt bis der Slider durch ist (§16: nur ab lg + ohne
// prefers-reduced-motion; sonst natives horizontales Scrollen). Kein Inline-JS (§8).
//
// Markup:
//   <section class="iba-hscroll" data-hscroll>
//     <div class="iba-hscroll__sticky">
//       <div class="container iba-hscroll__head"> … </div>
//       <div class="iba-hscroll__rail"><div data-hscroll-track> …Karten… </div></div>
//     </div>
//   </section>
export function initHScroll() {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.querySelectorAll("[data-hscroll]").forEach((section) => {
    const rail = section.querySelector(".iba-hscroll__rail");
    const track = section.querySelector("[data-hscroll-track]");
    const head = section.querySelector(".iba-hscroll__head");
    if (!rail || !track) return;

    let scrollable = 0;
    let pinned = false;

    const update = () => {
      if (!pinned || scrollable <= 0) return;
      const top = section.getBoundingClientRect().top;
      const progress = Math.min(1, Math.max(0, -top / scrollable));
      track.style.transform = "translateX(" + -progress * scrollable + "px)";
    };

    const measure = () => {
      // Erste/letzte Karte an der Container-Kante ausrichten.
      const edge = head ? Math.max(0, head.getBoundingClientRect().left) : 0;
      track.style.paddingLeft = edge + "px";
      track.style.paddingRight = edge + "px";
      rail.style.scrollPaddingLeft = edge + "px";
      track.style.transform = ""; // für die Messung in den Ausgangszustand

      // Never pin inside the Block Peek backend preview: the iframe grows with
      // the section height, which would feed back into innerHeight endlessly.
      pinned = window.innerWidth >= 992 && !reduce && !document.body.classList.contains("block-peek-content");

      if (pinned) {
        // Scrollstrecke aus der echten Position der letzten Karte berechnen
        // (scrollWidth eines Flex-Containers ignoriert das rechte Padding) —
        // so endet die letzte Karte bündig an der rechten Container-Kante.
        const last = track.lastElementChild;
        const lastRight = last ? last.getBoundingClientRect().right - track.getBoundingClientRect().left : 0;
        scrollable = Math.max(0, Math.round(lastRight + edge - rail.clientWidth));
      } else {
        scrollable = 0;
      }

      pinned = pinned && scrollable > 0;
      section.classList.toggle("is-pinned", pinned);

      if (pinned) {
        section.style.height = window.innerHeight + scrollable + "px";
        update();
      } else {
        section.style.height = "";
        track.style.transform = "";
      }
    };

    measure();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", measure);
    window.addEventListener("load", measure);
  });
}
